import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Marker } from '@outdoria/types';
import { fetcher } from '../utils';
import { ADMIN_MARKER_CREATE, ADMIN_MARKERS_ALL } from '../queryKeys';

export const useAdminCreateMarker = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (
    marker: Omit<Marker, 'marker_id'>,
  ): Promise<void> => {
    const response = await fetcher(`/v2/admin/markers`, {
      method: 'POST',
      body: JSON.stringify(marker),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 201)
      throw new Error((await response.json()).error ?? 'Did not work!');
    queryClient.invalidateQueries({ queryKey: ADMIN_MARKERS_ALL });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_MARKER_CREATE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
